import { isNil, omitBy, head } from 'lodash';
import { getAmountType } from './helper';

const getPaymentDetails = (payments) =>
	payments.map((payment) => ({
		account_id: payment.fromAccount,
		payment_context_id: payment.id,
	}));

const getBatchDetails = (payment, batchId) => [
	{
		account_id: payment.fromAccount,
		payment_context_id: batchId,
	},
];

export const createStaticEWOutcomeRequest = (data) => {
	const { userId, paymentDetails, customerType, isBatch, batchId } = data;
	const payment_details = isBatch ? getBatchDetails(head(paymentDetails), batchId) : getPaymentDetails(paymentDetails);

	const req = {
		effective_warning: {
			customer: {
				customer_id: userId,
				customer_segment: customerType,
			},
			other_payment: { payment_details },
		},
	};

	return JSON.stringify(omitBy(req, isNil));
};

export const createEWOutcomeRequest = (data) => {
	if (data.isStaticWarning) return createStaticEWOutcomeRequest(data);

	const {
		paymentAmount,
		userId,
		reasonId,
		reason,
		customerType,
		effectiveWarningId,
		accountDetails: {
			toAccount: { id: beneficiary_id, display_name: beneficiary_name, biller_id, sort_code, account_number },
			fromAccount,
		},
	} = data;

	const req = {
		effective_warning: {
			customer: {
				customer_id: userId,
				customer_segment: customerType,
			},
			account: {
				account_id: fromAccount.id,
				account_balance: getAmountType(fromAccount, 'available'),
				account_overdraft: getAmountType(fromAccount, 'available_overdraft'),
			},
			single_payment: {
				payment_id: effectiveWarningId,
				beneficiary_id,
				beneficiary_name,
				biller_id,
				sort_code,
				account_number,
				payment_amount: parseFloat(paymentAmount),
				payment_reason_id: reasonId,
				payment_reason: reason,
			},
		},
	};

	return JSON.stringify(omitBy(req, isNil));
};

export const createGenerateRetrievalIdRequest = (data) => {
	const { userId: customer_id, warningIds } = data;
	const req = {
		effective_warning: {
			customer: {
				customer_id,
			},
			effective_warning_ids: warningIds,
		},
	};
	return JSON.stringify(omitBy(req, isNil));
};

const getGuidanceDetailsFromPayment = (payment, batchId) => ({
	effective_warning_id: batchId || payment.id,
	debtor_account: {
		account_id: payment.fromAccount,
	},
});

const getAdditionalDetailsForPaymentGuidance = ({ paymentDetails, isStaticWarning, isBatch, batchId }) => {
	if (isBatch) return [getGuidanceDetailsFromPayment(paymentDetails[0], batchId)];
	if (isStaticWarning) return paymentDetails.map((payment) => getGuidanceDetailsFromPayment(payment));
	return getGuidanceDetailsFromPayment(paymentDetails[0]);
};

export const createAdditionalPaymentGuidanceRequest = (data) => {
	const { userId: customer_id, customerType: customer_segment } = data;

	const additionalDetails = getAdditionalDetailsForPaymentGuidance(data);

	const requestPayload = {
		customer: {
			customer_id,
			customer_segment,
		},
		additional_details: additionalDetails,
	};

	return JSON.stringify(requestPayload);
};

const getDetailsFromPayment = (payment, acknowledgement, outcomeType, batchId) => ({
	effective_warning_id: batchId || payment.id,
	acknowledgement: acknowledgement.toString(),
	outcome_type: outcomeType,
	debtor_account: {
		account_id: payment.fromAccount,
	},
});

const getAdditionalDetailsForOutcomeAcknowledgement = ({
	paymentDetails,
	isStaticWarning,
	acknowledgement,
	outcomeType,
	isBatch,
	batchId,
}) => {
	if (isBatch) return [getDetailsFromPayment(paymentDetails[0], acknowledgement, outcomeType, batchId)];
	if (isStaticWarning) {
		return paymentDetails.map((payment) => getDetailsFromPayment(payment, acknowledgement, outcomeType));
	}
	return getDetailsFromPayment(paymentDetails[0], acknowledgement, outcomeType);
};

export const createOutcomeAcknowledgementRequest = (data) => {
	const { userId: customer_id, customerType: customer_segment } = data;
	const additionalDetails = getAdditionalDetailsForOutcomeAcknowledgement(data);

	const requestPayload = {
		effective_warning: {
			customer: {
				customer_id,
				customer_segment,
			},
			outcomes: {
				additional_details: additionalDetails,
			},
		},
	};

	return JSON.stringify(requestPayload);
};
